// Die Leiste oben in der Akte (E3c, S2; G18: „wo bei wem was noch fehlt“):
// die acht Schritte der Kette als eine Reihe Kästchen – grün erledigt, hell
// „vor dem Update erledigt“, türkis offen (geht jetzt), orange wieder offen,
// grau gestrichelt „geht noch nicht“. Zeigen (Maus) oder Antippen (iPad,
// Handy) sagt, warum; ohne Antippen steht darunter, was jetzt geht. Danach,
// gestrichelt, was später kommt (Grundsatz 8). Am Laptop eine Reihe, am iPad
// zwei, am Handy vier.
//
// Die Kette rechnet der Kern (kette.ts) – hier steht nur, wie sie aussieht.

import { useState } from "react";
import { SCHRITT_STAND_WORTE, type Kette, type KettenSchritt } from "@happy-energy/kern";
import { Ikon } from "@happy-energy/oberflaeche";
import { leisteSatz, leisteText } from "./akte.ts";

export function Leiste({ kette }: { kette: Kette }) {
  const [gewaehlt, setGewaehlt] = useState<KettenSchritt | null>(null);
  const aktiv = kette.schritte.find((s) => s.schritt === gewaehlt) ?? null;
  return (
    <section className="crm-karte leiste-karte" aria-label="Die Schritte dieser Anlage">
      <ol className="kette-leiste">
        {kette.schritte.map((s, i) => (
          <li key={s.schritt} className={`kette-schritt ${s.stand}${s.hinweis ? " mit-hinweis" : ""}`}>
            <button
              type="button"
              // Der ganze Satz – beim Zeigen (title) und für Bildschirmleser (aria-label), mit Grund.
              title={leisteText(s)}
              aria-label={leisteText(s)}
              aria-pressed={gewaehlt === s.schritt}
              onClick={() => setGewaehlt((g) => (g === s.schritt ? null : s.schritt))}
            >
              <span className="kette-nr" aria-hidden="true">
                {s.hinweis ? <Ikon name="achtung" groesse="k" /> : i + 1}
              </span>
              <b>{s.name}</b>
              <span className="kette-stand">{SCHRITT_STAND_WORTE[s.stand]}</span>
            </button>
          </li>
        ))}
      </ol>
      <p className="kette-satz" aria-live="polite">
        {aktiv ? leisteText(aktiv) : leisteSatz(kette)}
      </p>
      <p className="kette-danach leise">Danach: Inbetriebnahme und Nachsorge – kommen später.</p>
    </section>
  );
}
